const gameGenres: string[] = [
  'Action',
  'Adventure',
  'Anime',
  'Arcade',
  'Board',
  'Battle Royal',
  'Collectible cards',
  'Dress-Up',
  'Family',
  'Farming',
  'Fighting',
  'Match 3',
  'MOBA',
  'Multiplayer',
  'Music',
  'Races',
  'Role-playing',
  'Sandbox',
  'Shooter',
  'Simulation',
  'Sports',
  'Strategy',
];

export default gameGenres;
